import {
    ActionService,
    ConfigurationService,
    EntityData,
    field,
    JwtHttpClientService,
    ResourceModule
} from "@fedelta-pos/data-client";
import {inject, Injectable} from "@angular/core";

export class TapToPayPaymentAuthorisationData extends EntityData<TapToPayPaymentAuthorisationData> {
    @field paymentRequestId: string;
    @field integratedPaymentConfigId: number;
    @field platformLiveMode: boolean;
    @field platformAccountId: string;
    @field clientSecret: string;
    @field orderRequestId: string;
    @field amount: number;
    @field platformApplicationFee: number;
    @field currency: string;
    @field firstName: string;
    @field lastName: string;
    @field email: string;
    @field phoneNumber: string;
    @field storeName: string;
    @field venueId: string;
    @field clientId: string;
}

/**
 * Service to create a tap-to-pay payment-intent on the server-side.
 */
@Injectable({providedIn: "root"})
export class TapToPayIntentCreationService extends ActionService {

    constructor() {
        const http: JwtHttpClientService = inject(JwtHttpClientService);
        const configService: ConfigurationService = inject(ConfigurationService);
        const nameSpace: string = inject<string>(ResourceModule.RESOURCE_NAMESPACE_KEY);
        const actionNames: string[] = inject<string[]>(ResourceModule.ACTION_NAMES_KEY);
        const useAsync: boolean = inject<boolean>(ResourceModule.RESOURCE_USE_ASYNC);

        console.log("--- TapToPayIntentCreationService");

        super(http, nameSpace, "tap-to-pay-intent-creation", configService, useAsync, actionNames);
    }
}
